module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/page-three.94217966.jpg";